import axios from '../../../../utils/axios';

/**
 * Fetches order items based on order type (card or cash)
 * @param {Object} order - The order object
 * @returns {Object} - The processed order with items
 */
export const fetchOrderItems = async (order) => {
  if (!order) return null;
  

  
  const orderToProcess = {...order};
  const orderId = order.id;
  const paymentMethod = order.payment_method;
  
  // If this is a card payment
  if (paymentMethod === 'card') {
    if (!orderId) return {...orderToProcess, items: []};
    
    try {
      // Check if this is a card order number (starts with ORD900)
      const isCardOrderNumber = typeof order.order_number === 'string' && order.order_number.startsWith('ORD900');
      
      // If we have a card order number, use that instead of the ID for more reliable results
      const identifier = isCardOrderNumber ? order.order_number : orderId;

      
      // Use the dedicated card order items endpoint
      const response = await axios.get(`/card-orders/${identifier}/items`);
      
      if (response.data && response.data.data && response.data.data.length > 0) {
        orderToProcess.items = response.data.data;
        
        // Ensure company information is preserved for card orders
        if (response.data.customer_type === 'company') {
          orderToProcess.customer_type = 'company';
          orderToProcess.company_name = response.data.company_name || orderToProcess.company_name;
          orderToProcess.company_tax_number = response.data.company_tax_number || orderToProcess.company_tax_number;
        }
      } else {
        orderToProcess.items = [];
      }
    } catch (error) {
      orderToProcess.items = [];
    }
  } else {
    // For cash orders, check if items exist, otherwise fetch them
    if (!orderToProcess.items || orderToProcess.items.length === 0) {
      if (!orderId) {
        orderToProcess.items = [];
      } else {
        try {
          // Explicitly specify this is a cash order
          const response = await axios.get(`/orders/${orderId}/items?order_type=cash`);
          
          if (response.data && response.data.data) {
            orderToProcess.items = response.data.data;
            
            // Ensure company information is preserved for cash orders
            if (response.data.customer_type === 'company') {
              orderToProcess.customer_type = 'company';
              orderToProcess.company_name = response.data.company_name || orderToProcess.company_name;
              orderToProcess.company_tax_number = response.data.company_tax_number || orderToProcess.company_tax_number;
            }
          } else {
            orderToProcess.items = [];
          }
        } catch (error) {
          orderToProcess.items = [];
        }
      }
    }
  }
  
  // Ensure company information is preserved regardless of order type
  if (order.customer_type === 'company') {
    orderToProcess.customer_type = 'company';
    orderToProcess.company_name = order.company_name;
    orderToProcess.company_tax_number = order.company_tax_number;
  }
  

  
  return orderToProcess;
};
